package utils

import kotlin.math.floor
import kotlin.math.round

fun <T : Number> T?.orElse(other: T) = this ?: other

/**
 * Formats a [Double] to one decimal place without using JVM-only String.format.
 * Works on all Kotlin Multiplatform targets (JVM, JS, Native).
 */
fun Double.toStringOneDecimal(): String {
    val rounded = round(this * 10.0) / 10.0
    val intPart = floor(rounded).toLong()
    val decPart = round((rounded - intPart) * 10.0).toLong()
    return "$intPart.$decPart"
}
